import cls from "classnames"

import Icon from "../../../../Icon"

const OnboardingSubStep = ({ label, status }) => {
  return (
    <button
      className={cls("ob-subStep", {
        "is-done": status === "done",
        "is-active": status === "active"
      })}
    >
      <span className="ob-subStep__text">{label}</span>

      {status === "active" && <Icon type="chevron_down_full" className="ob-subStep__chev" />}
    </button>
  )
}

export default OnboardingSubStep
